import { of, BehaviorSubject } from 'rxjs';
import { catchError, mergeMap, tap } from 'rxjs/operators';
import { ApiUxService } from '../../shared/api-ux/api-ux.service';
import { InitService } from './init-service.interface';

export abstract class ApiUxInitService<TData> implements InitService {
  public data: TData;

  protected _data$ = new BehaviorSubject<TData>(null);
  public data$ = this._data$.asObservable();

  constructor(protected apiUxService: ApiUxService, private path: string) {}

  getData() {
    return this.apiUxService.get<TData>(this.path);
  }
  processData(data: TData) {
    return of(data);
  }

  init() {
    return this.getData()
      .pipe(
        mergeMap(data => this.processData(data)),
        tap({
          next: data => {
            this.data = data;
            this._data$.next(data);
          },
        }),
        catchError(() => of())
      )
      .toPromise();
  }

  get(): TData {
    if (!this.data) {
      return null;
    }

    return this.data;
  }
}
